module.exports = __webpack_public_path__ + "static/media/money.0ef4a1fb.svg";